(function() {
  'use strict';

  function Search($translate, Utils) {
    var getSearch = function() {
      var search = {
        facetly: {
          facets: [
            {
              id: 'name',
              type: 'search',
              label: $translate.instant('Start typing to search')
            }
          ],
          options: {
            defaultFacet: 'name',
            placeholder: $translate.instant('Start typing to search...')
          }
        },
        filters: [
          {
            id: 'name',
            matchFunc: function(item, _key, value) {
              if (!value) { return true; }

              var val = value.toLowerCase(),
                  name = Utils.safeLowerStr(item.question, item.answer);
              return name.indexOf(val) > -1;
            }
          },
          {
            id: 'blueprintType'
          }
        ],
        orders: {
          name: function(item) {
            return item.question.toLowerCase();
          }
        },
        orderGroups: {
          name: {
            title: $translate.instant('name'),
            orders: ['name']
          }
        },
        defaultFilter: {
        },
        defaultOrder: 'name'
      };
      return search;
    };

    var service = {
      search: getSearch()
    };

    return service;
  }

  Search.$inject = ['$translate', 'UtilsService'];

  angular.module('component.faqs')
    .service('FAQSearch', Search);
})();
